<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Mqi7Os/tc-custom/9781504078245.jpg?1726574202444" alt="This image is the cover for the book Applegreen Cat, The Pat and Jean Abbott Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Applegreen Cat, The Pat and Jean Abbott Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <b>A witty whodunit set in WWII England starring “one of the more interesting married teams of detectives . . . A sort of globetrotting Nick and Nora” (<i>Thrilling Detective</i>).</b><br/>  <br/> While in England, Pat and Jean Abbott are focused on contributing to the war effort in whatever way they can, but they don’t mind taking a weekend to join some other American expats at the country home of advertising man Steve Hayward and his wife. But before much fun can be had, a body is found on the premises. Pat isn’t so sure that everyone’s impulse to blame the death on a passing drifter or a Nazi spy is the answer—and when the spotlight of suspicion falls on a member of a house party he’s sure is innocent, he starts getting reluctantly involved in the case . . .<br/>  <br/><b>Praise for the Pat and Jean Abbott Mysteries</b><br/>  <br/> “Lively and exciting.” —<i>The New York Times</i><br/>  <br/> “Well-plotted and mystifying.” —<i>Saturday Review</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Frances Crane
      </h2>
      
      <p class="authorDescription body article">Frances Crane (1890&ndash;1981) was an American author and former writer for the<I> New Yorker</I>. She was invited to leave Nazi Germany in the late 1930s after writing a number of unfavorable articles about Hitler. After settling in Taos, New Mexico, Crane introduced private investigator Pat Abbott and his future wife Jean in her first novel, <I>The Turquoise Shop</I> (1941). The Abbotts investigated crimes in a total of twenty-six volumes, each with a color in the title, with settings around the country and globe.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?73104fc6